module.exports = __webpack_public_path__ + "static/img/sm_10.dad3ea4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/sm_10.png
// module id = mv3K
// module chunks = 0